window.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.aps-cpd-discover').length) {
    let $discover = document.querySelector('.aps-cpd-discover')
    let $cards = $discover.querySelectorAll('.aps-cpd-card')
    $cards = Array.from($cards)

    for (let $card of $cards) {
      const $counter = $card.querySelector('.aps-cpd-card__events-counter')
      const $eventList = $card.querySelectorAll('.aps-cpd-card__event')
      const eventsCount = $eventList.length

      //handle hiding of list of events
      const hideEventsList = function () {
        if ($eventList.length >= 5) {
          for (let i = 1; i < $eventList.length; i++) {
            $eventList[i].classList.add('aps-cpd-card__event--hidden')
          }
          $counter.getElementsByTagName('span')[0].textContent = eventsCount - 1
          $counter.classList.add('aps-cpd-card__events-counter--visible')
        }
      }

      //handle display of list of events
      const showEventsList = function () {
        if ($eventList.length >= 5) {
          for (let i = 1; i < $eventList.length; i++) {
            $eventList[i].classList.remove('aps-cpd-card__event--hidden')
          }
          $counter.getElementsByTagName('span')[0].textContent = eventsCount - 1
          $counter.classList.remove('aps-cpd-card__events-counter--visible')
        }
      }

      hideEventsList()

      // add listeners
      $card.addEventListener('mouseenter', showEventsList)
      $card.addEventListener('mouseleave', hideEventsList)
      $card.addEventListener('focus', showEventsList)
      $card.addEventListener('blur', hideEventsList)
    }
  }
})
